import { createApp } from '@app/adapters/create-app'
import createStore from '@app/insights/store'
import { initInsightsRootFromDataset } from '@app/insights/store/insights-root'
import type { Store } from 'vuex'
import { createRouter, createWebHistory } from 'vue-router'
import type { App as Application } from 'vue'

import InsightsFloatingSidepane from '@app/insights/components/insights-floating-sidepane.vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const element = doc.querySelector(
    "[data-behaviour='insights/floating-sidepane']"
  ) as HTMLElement

  if (!element) return

  const store = createStore() as Store<unknown>

  // The router instance is required because descendants such as
  // segment-info.vue read `this.$route.query`. The routes array is
  // intentionally empty: the root component is mounted directly, not
  // through <router-view>.
  const router = createRouter({
    history: createWebHistory(),
    routes: [
      {
        path: '/f/:firmid/insights/companies_overview',
        name: 'InsightsLeftDrawer',
        component: InsightsFloatingSidepane,
      },
    ],
  })

  const app: Application = createApp(InsightsFloatingSidepane, {
    isLite: element.dataset.liteInsights === 'true',
  })

  app.use(store)
  app.use(router)

  initInsightsRootFromDataset(element.dataset)

  app.mount(element)
})
